import { render } from "./ObjManageListItem.vue?vue&type=template&id=d233977a&scoped=true"
import script from "./ObjManageListItem.vue?vue&type=script&lang=js"
export * from "./ObjManageListItem.vue?vue&type=script&lang=js"

import "./ObjManageListItem.vue?vue&type=style&index=0&id=d233977a&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d233977a"]])

export default __exports__